import useBulkActions from "@entities/brief/lib/hooks/useBulkActions";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { ToastService } from "@shared/lib/services";
import { BriefNotificationActionType } from "@shared/lib/types/brief";
import { IBriefInfluencerSearchRequestV2 } from "@shared/lib/types/briefInfluencerV2";
import { useCallback, useEffect } from "react";

export function useMarkPendingReviewAsSeen() {
  const { briefId } = useBriefStore();
  const { bulkActions, isBulkActions, isBulkActionsSuccess } = useBulkActions();

  useEffect(() => {
    if (!isBulkActionsSuccess) return;
    ToastService.success("Marking brand updates as seen…");
  }, [isBulkActionsSuccess]);

  const markAsSeen = useCallback(
    (
      filterParams: Partial<IBriefInfluencerSearchRequestV2>,
      type: "brief" | "campaignInfluencer"
    ) => {
      if (!briefId || isBulkActions) return;
      bulkActions({
        briefId,
        actionType:
          type === "brief"
            ? BriefNotificationActionType.markPendingReviewAsSeen
            : BriefNotificationActionType.markPendingReviewAsSeenOnCampaignInfluencer,
        ids: [],
        isSelectAll: true,
        notIncludeIds: [],
        filterParams,
        actionParams: {},
      });
    },
    [briefId, bulkActions, isBulkActions]
  );

  return {
    markAsSeen,
    isMarkAsSeenLoading: isBulkActions,
  };
}
